import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { trackError } from './telemetry';
import reportWebVitals from './reportWebVitals';

// Global handlers: route uncaught errors + promise rejections through the
// same telemetry sink as the ErrorBoundary so we capture async failures too.
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    trackError(event.error || new Error(event.message || 'window.error'), {
      route: window.location.pathname,
      recording_session_id: window.__rsid
    });
  });
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
    trackError(reason, {
      route: window.location.pathname,
      recording_session_id: window.__rsid,
      unhandled_rejection: true
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
